<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    persistent
    width="500"
    transition="dialog-bottom-transition"
  >
    <v-card v-if="deliveryData != null">
      <v-card-title>
        <strong>เรียกคนขับ</strong>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 640px">
        <div class="mt-5">
          <v-row class="text-center">
            <v-col v-for="(item, key) in logistics" :key="key" cols="4">
              <div
                v-bind:class="{ selected: item.selected }"
                class="select-box text-center"
                @click="onLogisticChanged(item)"
              >
                <img :src="item.icon" style="width:50%;" />
                <br />
                <div class="font-weight-bold">{{ item.title }}</div>
                <div v-if="!item.status">Coming Soon...</div>
                <div v-else>&nbsp;</div>
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <div style="display: none">{{ delivery }}</div>
          <h3 class="mx-4 mb-3 subtitle">เส้นทางจัดส่ง</h3>
          <el-timeline>
            <el-timeline-item
              v-for="(stop, index) in stops"
              :key="index"
              :size="`large`"
            >
              <strong class="deep-orange--text">{{
                stop.addresses.en_TH.displayString
              }}</strong>
              <br />
              {{ stop.contact.name }} | {{ stop.contact.mobile }}
            </el-timeline-item>
          </el-timeline>
          <!--
            <h4 class="mx-4">เวลารับสินค้า</h4>
            <div class="mx-4">{{new Date(deliveryData.datetimeReceived)}}</div>
          -->
        </div>
        <div class="ma-4 text-left">
          <h3 class="my-2 subtitle">บริการเสริม</h3>
          <div>
            <el-checkbox
              :disabled="true"
              v-model="services.lalabag"
              label="กล่องอาหาร (Free)"
            ></el-checkbox>
          </div>
          <!-- <div>
            <el-checkbox
              :disabled="true"
              v-model="services.tier_1"
              label="Purchase T1 (+25THB)"
            ></el-checkbox>
          </div>
          <div>
            <el-checkbox
              :disabled="true"
              v-model="services.tier_2"
              label="Purchase T2 (+30THB)"
            ></el-checkbox>
          </div> -->
        </div>
        <div>
          <el-input
            type="textarea"
            :disabled="true"
            :autosize="{ minRows: 4, maxRows: 4 }"
            placeholder="ข้อความถึงคนขับ"
            v-model="remark"
          ></el-input>
        </div>
        <v-divider class="my-3"></v-divider>
        <template v-if="requestData != null">
          <v-row>
            <v-col>
              <!-- เวลา
              <h3 class="subtitle font-weight-bold">{{ scheduleAt }}</h3> -->
              <!--
                <el-button type="text">Change</el-button>
              -->
            </v-col>
            <v-col class="text-right">
              ราคา
              <h3 class="subtitle font-weight-bold">฿ {{ deliveryFee }}</h3>
            </v-col>
          </v-row>
        </template>
        <template v-if="isError">
          <div class="mt-3">
            <el-alert
              :title="errorMessage"
              type="error"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
        </template>
      </v-card-text>
      <v-card-actions>
        <el-button
          v-if="requestData != null && !isPass"
          type="primary"
          class="el-btn-full"
          :loading="loading"
          @click="requestDriver"
          >เรียกคนขับรถ</el-button
        >
        <el-button v-else type="primary" :disabled="true" class="el-btn-full"
          >Loading...</el-button
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../services";
import moment from "moment";
import { monthList } from "../utils/Constants";

export default {
  name: "driver-dialog",
  props: {
    showDialog: { default: false },
    deliveryData: { default: null },
    order: { default: null },
  },
  data() {
    return {
      loading: false,
      isPass: false,
      isError: false,
      errorMessage: "",
      stops: [],
      deliveryFee: 0,
      scheduleAt: null,
      requestData: null,
      remark: "",
      services: { lalabag: true, tier_1: false, tier_2: false },
      logistics: [
        {
          key: "lalamove",
          title: "Lalamove",
          status: true,
          selected: true,
          icon: require("@/assets/img/icon-lalamove.png"),
        },
        {
          key: "lalamove-car",
          title: "Lalamove Car",
          status: true,
          selected: false,
          icon: require("@/assets/img/icon-lalamove.png"),
        },
        {
          key: "grab-instant",
          title: "Grab Express",
          status: true,
          selected: false,
          icon: require("@/assets/img/icon-grab-instant.png"),
        },
        // {
        //   key: "zeek",
        //   title: "Zeek",
        //   status: false,
        //   selected: false,
        //   icon: require("@/assets/img/icon-zeek.png"),
        // },
      ],
      quotation: null,
      selectedDriverKey: "lalamove",
    };
  },
  watch: {
    showDialog(val) {
      this.fetchData();
    },
  },
  computed: {
    delivery: {
      get() {
        // if (this.deliveryData != null) {
        //   this.loading = true;
        //   // let index = this.logistics.findIndex((x) => x.key == item.key);
        //   this.logistics[0].selected = true;
        //   this.selectedDriverKey = "lalamove";
        //   let d = { order_id: this.order.order_id, logistic: "lalamove" };
        //   Service.Driver.getQuotation(d).then((res) => {
        //     this.quotation = res.data;
        //     this.deliveryFee = res.data.amount;
        //     this.requestData = res.data;
        //     this.loading = false;
        //   });
        //   return;
        //   let now = new Date();
        //   let shop = {
        //     name: this.order.shop.name,
        //     mobile: this.order.shop.contacts.find((x) => x.type == "mobile")
        //       .value,
        //   };
        //   let recipient = {
        //     name: this.order.user_ref_json.firstname,
        //     mobile: this.order.user_ref_json.mobile,
        //   };
        //   this.stops = [];
        //   this.deliveryFee = 0;
        //   this.scheduleAt = null;
        //   this.requestData = null;
        //   let from = {
        //     location: {
        //       lat: this.deliveryData.deliveryInfo.whereFrom.latitude.toString(),
        //       lng: this.deliveryData.deliveryInfo.whereFrom.longitude.toString(),
        //     },
        //     addresses: {
        //       en_TH: {
        //         displayString: this.deliveryData.deliveryInfo.whereFrom
        //           .formatted_address,
        //         country: "TH",
        //       },
        //     },
        //     contact: {
        //       name: shop.name,
        //       mobile: shop.mobile,
        //     },
        //   };
        //   let displayString;
        //   //console.log(this.deliveryData);
        //   if (this.deliveryData.deliveryInfo.whereTo.name) {
        //     displayString = this.deliveryData.deliveryInfo.whereTo.name;
        //   } else {
        //     displayString = this.deliveryData.deliveryInfo.whereTo.address;
        //   }
        //   let to = {
        //     location: {
        //       lat: this.deliveryData.deliveryInfo.whereTo.lat.toString(),
        //       lng: this.deliveryData.deliveryInfo.whereTo.lng.toString(),
        //     },
        //     addresses: {
        //       en_TH: {
        //         displayString: displayString,
        //         country: "TH",
        //       },
        //     },
        //     contact: {
        //       name: recipient.name,
        //       mobile: recipient.mobile,
        //     },
        //   };
        //   this.stops.push(from);
        //   this.stops.push(to);
        //   let basket = "";
        //   let totalAmount = parseInt(
        //     this.order.amount.food +
        //       this.order.amount.delivery +
        //       this.order.amount.extra
        //   );
        //   let lalamoveFee = parseInt(
        //     this.order.amount.delivery + this.order.amount.extra
        //   );
        //   this.order.order_basket.product_list.map((item) => {
        //     basket += "  - " + item.name + " (x" + item.quantity + ")\n";
        //   });
        //   let ent_code = "HLZ";
        //   Service.Shop.get(this.order.shop.shop_id).then((res) => {
        //     ent_code = res.data.enterprise.ent_code;
        //     if (this.order.payment_type == "cash") {
        //       this.remark =
        //         "[" +
        //         ent_code +
        //         " #" +
        //         this.deliveryData.orderId +
        //         "] " +
        //         shop.name +
        //         "\n" +
        //         basket +
        //         "\nสั่งอาหารหน้าร้าน หรือโทร. " +
        //         shop.mobile +
        //         "\nค่าอาหาร ฿" +
        //         this.order.amount.food +
        //         " / ค่าจัดส่ง ฿" +
        //         lalamoveFee +
        //         "\n**เก็บเงินลูกค้า ฿" +
        //         totalAmount;
        //     } else {
        //       this.remark =
        //         "[" +
        //         ent_code +
        //         " #" +
        //         this.deliveryData.orderId +
        //         "] รับอาหารจากร้าน " +
        //         this.order.shop.name +
        //         "\nและนำไปส่ง\n\nแจ้งเลขที่ออเดอร์นี้ที่ร้านอาหาร";
        //     }
        //   });
        //   /*
        //      +
        //     this.deliveryData.deliveryInfo.whereFrom.name +
        //     " ไปส่งให้คุณ " +
        //     this.deliveryData.recipientInfo.firstname +
        //     " (โทร. " +
        //     this.deliveryData.recipientInfo.mobile +
        //     ")"
        //   */
        //   let special_requests = ["LALABAG"];
        //   if (this.order.payment_type == "cash") {
        //     if (this.order.amount.food <= 1000) {
        //       special_requests.push("HELP_BUY");
        //       this.services.tier_1 = true;
        //     } else {
        //       special_requests.push("PURCHASE_SERVICE_TIER_2");
        //       this.services.tier_2 = true;
        //     }
        //   }
        //   let paymentMethod = "CASH";
        //   if (this.order.payment_type != "cash") {
        //     paymentMethod = "WALLET";
        //   }
        //   let schedule_at = this.deliveryData.datetimeReceived;
        //   if (this.order.cluster_id != null) {
        //     schedule_at = moment(this.order.datetime_received);
        //     schedule_at = schedule_at
        //       .subtract(30, "minutes")
        //       .format("YYYY-MM-DD HH:mm");
        //   }
        //   let data = {
        //     schedule_at: schedule_at,
        //     special_requests: special_requests,
        //     stops: this.stops,
        //     remarks: this.remark,
        //     paymentMethod: paymentMethod,
        //     shop_id: parseInt(this.order.shop_id),
        //     basket: this.order.order_basket.product_list,
        //     promocode: { value: "" },
        //   };
        //   if (
        //     new Date(this.deliveryData.datetimeReceived) <
        //     new Date(now + 30 * 60000)
        //   ) {
        //     let asapDate = new Date(new Date().getTime() + 30 * 60000);
        //     data.schedule_at = "asap";
        //   }
        //   Service.Delivery.getDeliveryFee(data)
        //     .then((res) => {
        //       if (res.success) {
        //         let date = new Date(res.data.scheduleAt);
        //         this.scheduleAt =
        //           date.getDate() +
        //           " " +
        //           monthList[date.getMonth()] +
        //           " " +
        //           date.getFullYear() +
        //           " " +
        //           this.pad(date.getHours()) +
        //           ":" +
        //           this.pad(date.getMinutes());
        //         this.deliveryFee = parseFloat(
        //           res.data.order.amount.delivery_fee
        //         );
        //         this.requestData = res.data;
        //       }
        //     })
        //     .catch((err) => {});
        // }
        // //return this.deliveryData;
      },
      set(value) {
        // If close dialog.
        if (!value) {
        }
      },
    },
  },
  created() {
    // Service.Order.requestDriver(this.order.order_id, null).then((res) => {
    //   console.log(res);
    // });
  },
  methods: {
    fetchData() {
      let data = { order_id: this.order.order_id, logistic: "lalamove" };
      Service.Driver.getQuotation(data).then((res) => {
        this.quotation = res.data;
        this.deliveryFee = res.data.amount;
        this.requestData = res.data;
        this.loading = false;
      });
    },
    requestDriver2() {
      this.loading = true;
      let data = {
        order_id: this.order.order_id,
        logistic: this.selectedDriverKey,
      };
      Service.Driver.requestDriver(data)
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.$emit("save", res.data);
        })
        .catch((err) => {
          this.loading = false;
          this.isError = true;
          if (err.message == "This order already has driver.") {
            this.errorMessage =
              "ไม่สามารถเรียกรถ ได้เนื่องจากออเดอร์ได้เรียกรถไปแล้ว กรุณาติดต่อเจ้าหน้าที่";
          }
          console.log(err);
        });
    },
    requestDriver() {
      this.loading = true;
      this.requestData = {
        ...this.requestData,
        remarks: this.remark,
        logistic: this.selectedDriverKey,
      };
      console.log(JSON.stringify(this.requestData));
      Service.Order.requestDriver(this.deliveryData.orderId, this.requestData)
        .then((res) => {
          if (res.success) {
            this.loading = false;
            this.$emit("save", res.data);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.isError = true;
          if (err.message == "This order already has driver.") {
            this.errorMessage =
              "ไม่สามารถเรียกรถ ได้เนื่องจากออเดอร์ได้เรียกรถไปแล้ว กรุณาติดต่อเจ้าหน้าที่";
          }
          console.log(err);
        });
    },
    onLogisticChanged(item) {
      if (!item.status) {
        return;
      }

      this.logistics = this.logistics.map((item) => {
        return { ...item, selected: false };
      });
      this.loading = true;
      let index = this.logistics.findIndex((x) => x.key == item.key);
      this.logistics[index].selected = true;
      this.selectedDriverKey = item.key;

      let data = { order_id: this.order.order_id, logistic: item.key };
      Service.Driver.getQuotation(data).then((res) => {
        this.quotation = res.data;
        this.deliveryFee = res.data.amount;
        this.loading = false;
      });
    },
    close() {
      this.isError = false;
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.form);
    },
    pad(n) {
      return n < 10 ? "0" + n : n;
    },
  },
};
</script>
